var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      _vm._b(
        {
          staticClass: "card custom-card box-shadow data-load",
          class: ["custom-card--" + _vm.tone, { "sk-loading": _vm.isLoading }],
        },
        "div",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.isLoading ? _c("sk-spinner") : _vm._e(),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _vm._t(
            "body",
            function () {
              return [
                _c(
                  "div",
                  { staticClass: "custom-card__head" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "custom-card__icon",
                        attrs: { "aria-hidden": "true" },
                      },
                      [_c("i", { staticClass: "fas", class: _vm.icon })]
                    ),
                    _vm._t(
                      "title",
                      function () {
                        return [
                          _c("h5", { staticClass: "card-title" }, [
                            _vm._v(_vm._s(_vm.title)),
                          ]),
                        ]
                      },
                      { value: _vm.value, title: _vm.title }
                    ),
                  ],
                  2
                ),
                _vm._t(
                  "value",
                  function () {
                    return [
                      _c(
                        "p",
                        {
                          staticClass: "card-text",
                          on: {
                            click: function ($event) {
                              return _vm.valueClicked(_vm.value)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.value))]
                      ),
                    ]
                  },
                  { value: _vm.value, title: _vm.title }
                ),
              ]
            },
            { value: _vm.value, title: _vm.title }
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }